import React from 'react'
import { Link } from 'gatsby'

const HiringBanner: React.FC<{
  closeCallback: () => void
  hiddenClass: string
  data?: HiringBanner
}> = ({ closeCallback, hiddenClass, data }) => {
  if (!data) {
    return null
  }

  return (
    <div className={`hiring-banner-wr ${hiddenClass}`}>
      <Link to={data.url}/>
      <img
        src={data.image}
        alt={data.image_alt_text}
        title={data.image_alt_text}
      />
      <div className="content">
        <div className="title">{data.title}</div>
        <div className="subtitle">{data.subtitle}</div>
      </div>
      <button className="close" onClick={closeCallback}>
        x
      </button>
    </div>
  )
}

export const COOKIE_HIRING = 'bn_hiring'

export default HiringBanner
